<script setup>
import { onMounted, ref } from 'vue';
import { useRoute } from 'vue-router';
import { useI18n } from 'vue-i18n';
import BaseSettingsHeader from '../components/BaseSettingsHeader.vue';
import Button from 'dashboard/components-next/button/Button.vue';
import AiKnowledgeSourcesManager from './AiKnowledgeSourcesManager.vue';

const { t } = useI18n();
const route = useRoute();
const managerRef = ref(null);

const openAddPanel = () => {
  managerRef.value?.openAddPanel();
};

onMounted(() => {
  if (route.query.add === '1') {
    openAddPanel();
  }
});
</script>

<template>
  <div class="flex w-full min-w-0 max-w-none flex-col gap-6">
    <BaseSettingsHeader
      :title="t('AI_AGENTS.KNOWLEDGE.SETTINGS_TITLE')"
      :description="t('AI_AGENTS.KNOWLEDGE.SETTINGS_PAGE_DESCRIPTION')"
      title-icon="i-lucide-book-open"
    >
      <template #actions>
        <Button
          :label="t('AI_AGENTS.KNOWLEDGE.ADD_SOURCE')"
          icon="i-lucide-plus"
          size="sm"
          @click="openAddPanel"
        />
      </template>
    </BaseSettingsHeader>
    <div class="min-w-0 px-8 pb-8 md:px-10">
      <AiKnowledgeSourcesManager ref="managerRef" />
    </div>
  </div>
</template>
